import React from 'react';
import Logo from '../common/Logo';
import Footer from './Footer';
import { getCachedPreLaunchEnabled } from '../../utils/preLaunchConfigCache';

function PreLaunchLayout({ children }) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="border-b border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-center">
          <Logo variant="detailed" />
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function PreLaunchExemptRoute({ children }) {
  const isPreLaunch = getCachedPreLaunchEnabled();

  if (isPreLaunch) {
    return <PreLaunchLayout>{children}</PreLaunchLayout>;
  }

  return children;
}

export { PreLaunchLayout };
